module.exports = __webpack_public_path__ + "img/Empfangen_reihenfolge_1.77803a7e.png";